import ApiServer from "../../ApiServer.js";
import * as i18n from "../../i18n.ts";
import {ListCache} from "../../lib/SyncCache.ts";

const ColorCache = new ListCache(ApiServer.colorlist);

ApiServer.types.ColorBean.prototype.onDecode = function(json){
  this.defaultName = i18n.get("color."+this.colorSystem);
  this.name = this.name ? this.name.trim().replace(/\s+/g,' ') : this.defaultName;
}

export {ColorCache}